// extracted by mini-css-extract-plugin
export default {"main":"newsletterModal_main__08vdW","close":"newsletterModal_close__KIfHB"};